var styles = {"seals":"index-module_seals__N9M-m","iconOnly":"index-module_iconOnly__e2P0h","sealDescription":"index-module_sealDescription__lLAR2","seal":"index-module_seal__O11ci","icon":"index-module_icon__7jOSQ"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
